import { render } from "./your-info.vue?vue&type=template&id=b70035c8&scoped=true&ts=true"
import script from "./your-info.vue?vue&type=script&lang=ts"
export * from "./your-info.vue?vue&type=script&lang=ts"

import "./your-info.vue?vue&type=style&index=0&id=b70035c8&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b70035c8"]])

export default __exports__